import { useMemo, useSyncExternalStore } from 'react';
import { statsigStore } from '../bootstrap/statsigStore';
import {
	deriveIsRovoContextMenuEnabled,
	deriveIsRovoContextMenuHighlightFabEnabled,
	deriveIsRovoContextMenuHighlightMenuDirect,
	deriveIsRovoContextMenuHighlightOneLineMenuEnabled,
	deriveIsRovoContextMenuRightClickFabEnabled,
	deriveIsRovoContextMenuRightClickOneLineMenuEnabled,
	deriveIsRovoContextMenuSearchFullPageEnabled,
	deriveIsRovoContextMenuSearchInSidePanelEnabled,
	getAllRovoContextMenuVariants,
	type RovoContextMenuHighlightEntryVariant,
	type RovoContextMenuRightClickVariant,
	type RovoContextMenuSearchBehaviorVariant,
} from '../experiment/experiments';

export type ProactiveContextMenuVariants = {
	highlightEntry: RovoContextMenuHighlightEntryVariant;
	rightClickMenu: RovoContextMenuRightClickVariant;
	searchBehavior: RovoContextMenuSearchBehaviorVariant;
	isRovoContextMenuEnabled: boolean;
	isHighlightFabEnabled: boolean;
	isHighlightMenuDirect: boolean;
	isHighlightOneLineMenuEnabled: boolean;
	isRightClickFabEnabled: boolean;
	isRightClickOneLineMenuEnabled: boolean;
	isSearchInSidePanelEnabled: boolean;
	isSearchFullPageEnabled: boolean;
};

export const useProactiveContextMenuVariants = (): ProactiveContextMenuVariants => {
	const statsigVersion = useSyncExternalStore(
		statsigStore.subscribe,
		statsigStore.getSnapshot,
		statsigStore.getSnapshot,
	);

	return useMemo<ProactiveContextMenuVariants>(() => {
		const { highlightEntry, rightClickMenu, searchBehavior } = getAllRovoContextMenuVariants();
		return {
			highlightEntry,
			rightClickMenu,
			searchBehavior,
			isRovoContextMenuEnabled: deriveIsRovoContextMenuEnabled(
				highlightEntry,
				rightClickMenu,
				searchBehavior,
			),
			isHighlightFabEnabled: deriveIsRovoContextMenuHighlightFabEnabled(highlightEntry),
			isHighlightMenuDirect: deriveIsRovoContextMenuHighlightMenuDirect(highlightEntry),
			isHighlightOneLineMenuEnabled:
				deriveIsRovoContextMenuHighlightOneLineMenuEnabled(highlightEntry),
			isRightClickFabEnabled: deriveIsRovoContextMenuRightClickFabEnabled(rightClickMenu),
			isRightClickOneLineMenuEnabled:
				deriveIsRovoContextMenuRightClickOneLineMenuEnabled(rightClickMenu),
			isSearchInSidePanelEnabled: deriveIsRovoContextMenuSearchInSidePanelEnabled(searchBehavior),
			isSearchFullPageEnabled: deriveIsRovoContextMenuSearchFullPageEnabled(searchBehavior),
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [statsigVersion]);
};
